<template>
  <div>
    <p>
      {{ $t('notConnected') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotConnected',
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
notConnected: It looks like your camera is not connected. Please connect your camera.
</i18n>

<i18n locale="ru" lang="yaml">
notConnected: Похоже, что ваша камера не подключена. Пожалуйста подключите камеру.
</i18n>
